// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__5Oe3k","profile":"Sidebar_profile__p26a4","menuWrapper":"Sidebar_menuWrapper__UfefL","item":"Sidebar_item__aVViW","child":"Sidebar_child__VJbTd"};